<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Areas">
      <button class="btn btn-secondary" @click="syncAreas" v-submitting="submitting">
        Sync Areas
      </button>
    </PageHeader>

    <div class="container">
      <Loading v-if="loading" />

      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="areas.meta.total < 1" class="py-12 text-center">
          <p class="mb-8 text-lg font-bold">
            No areas have been sync'd from WEBFLEET yet.
          </p> 
          <button class="btn btn-secondary" @click="syncAreas" v-submitting="submitting">
            Sync Areas from WEBFLEET
          </button>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table :items="areas.data" 
            :keys="[
              { name: 'Name', slug: 'areaname', class: 'font-bold' },
              { name: 'Number', slug: 'areano' },
              { name: 'Type', slug: 'type', display: (val) => parseAreaType(val) }
            ]" />
          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="areas.meta.total" :per-page="areas.meta.per_page" :current-page="areas.meta.current_page" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AreaList',

  metaInfo: {
    title: 'Areas'
  },

  async created () {
    await this.getAreas()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      areas: {},
      loading: true,
      submitting: false
    }
  },

  methods: {
    async getAreas () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/areas`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.areas = data.areas
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },
    
    async syncAreas () {
      try {
        this.submitting = true
        await this.$api.get(`account/${this.$route.params.account}/sync/areas`)
        this.getAreas()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    },

    parseAreaType (code) {
      const typeEnum = {
        '1': 'rectangle',
        '2': 'circle',
        '3': 'polygon',
        '4': 'corridor'
      }
      return typeEnum[code.toString()]
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getAreas()
      },
      deep: true
    }
  }
}
</script>